export const CookieKey = {
    session_expiry: 'session_expiry',
    session_idle: 'session_idle_expiry_time',
    last_logged_in_email: 'last_logged_in_email',
    last_logged_in_cs: 'last_logged_in_cs',
    access_token: 'access_token',
    remember_me: 'remember_me',
};
